import { useState, useEffect } from 'react';
import { getRemainingMinutes } from '../utils/statusModalUtils';
import { useIsUngatedForRoutingAwayStatusTimer } from '../../auth/hooks/useGates';
export const useAgentRemainingAwayMinutes = awayStatusTimer => {
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const isUngatedForRoutingAwayStatusTimer = useIsUngatedForRoutingAwayStatusTimer();
  useEffect(() => {
    if (!isUngatedForRoutingAwayStatusTimer) return;
    if (awayStatusTimer) {
      setRemainingMinutes(getRemainingMinutes(awayStatusTimer));
      const timer = setInterval(() => {
        const remaining = getRemainingMinutes(awayStatusTimer);
        setRemainingMinutes(remaining);
        if (remaining === 0 || remaining === null) {
          clearInterval(timer);
        }
      }, 60000);
      return () => clearInterval(timer);
    } else {
      setRemainingMinutes(0);
    }
  }, [awayStatusTimer, isUngatedForRoutingAwayStatusTimer]);
  return remainingMinutes;
};